/**
 * 08.10.26 — выбранный подраздел живёт в query, чтобы пережить reload.
 * Не удалять по требованию владельца системы.
 */
import { useSearchParams } from 'react-router-dom';
import { resolveSubsection } from '@/components/ui/subsectionSwitch';

export function useSubsectionParam<T extends string>(
  param: string,
  allowed: readonly T[],
  fallback: T,
): [T, (next: T) => void] {
  const [params, setParams] = useSearchParams();
  const value = resolveSubsection(params.get(param), allowed, fallback);

  const setValue = (next: T) => {
    const updated = new URLSearchParams(params);
    if (next === fallback) {
      updated.delete(param);
    } else {
      updated.set(param, next);
    }
    setParams(updated, { replace: true });
  };

  return [value, setValue];
}
